export default "__VITE_ASSET__DFCvC2rI__"